import * as React from 'react';

import { NewbuildingSpecialProject } from './NewbuildingSpecialProject';
import { NewbuildingSpecialProjectAnimated } from './NewbuildingSpecialProjectAnimated';
import { INewbuildingSpecialProjectBannerContext } from '../../../../../../types/adfox';
import { useAdfoxContext } from 'shared/utils/AdfoxContext';
import { useApplicationContext } from 'shared/utils/applicationContext';

export interface INewbuildingSpecialProjectContainerProps {
  context: INewbuildingSpecialProjectBannerContext;
}

export function NewbuildingSpecialProjectContainer({ context }: INewbuildingSpecialProjectContainerProps) {
  const { sizes } = useAdfoxContext();
  const { config } = useApplicationContext();
  const isAnimatedEnabled = config.get<boolean>('newbuildingSpecialProjectBannerAnimated.Enabled');

  if (Number(context.isAnimating) && isAnimatedEnabled) {
    return <NewbuildingSpecialProjectAnimated context={context} sizes={sizes} />;
  }

  return <NewbuildingSpecialProject context={context} sizes={sizes} />;
}
